import { render, staticRenderFns } from "./roomInfoModule.vue?vue&type=template&id=966cd8a0&scoped=true"
import script from "./roomInfoModule.vue?vue&type=script&lang=js"
export * from "./roomInfoModule.vue?vue&type=script&lang=js"
import style0 from "./roomInfoModule.vue?vue&type=style&index=0&id=966cd8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966cd8a0",
  null
  
)

export default component.exports